// extracted by mini-css-extract-plugin
export default {"wrapper":"ThemeList_wrapper__TVZqf","list":"ThemeList_list__R0CAo","title":"ThemeList_title__vXuez","test":"ThemeList_test__vGyM-"};